var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20,
    x: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,12v-1c-1.67,0-3.28-0.85-4.11-2.16C11.55,8.29,10.91,8,10.27,8H9.73C9.09,8,8.45,8.29,8.11,8.84 C7.28,10.15,5.67,11,4,11v1c2,0,3.51-0.75,4.5-1.96v2.45l-2.77,1.19C5.29,13.88,5,14.31,5,14.79C5,15.46,5.54,16,6.21,16H8 c0,0,0-0.11,0-0.25C8,14.79,8.79,14,9.75,14h2c0.14,0,0.25,0.11,0.25,0.25s-0.11,0.25-0.25,0.25h-2c-0.69,0-1.25,0.56-1.25,1.25 c0,0.05,0,0.25,0,0.25h5.29c0.67,0,1.21-0.54,1.21-1.21c0-0.48-0.29-0.92-0.73-1.11L11.5,12.5v-2.45C12.49,11.25,14,12,16,12z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.75c6f331.svg";
export { ForwardRef as ReactComponent };